import React from "react";

const Th = ({ children, onClick, active, dir, align = "left" }) => (
  <th
    onClick={onClick}
    className={`px-4 py-4 text-[11px] uppercase tracking-widest text-gray-500 font-semibold ${
      onClick ? "cursor-pointer select-none" : ""
    } ${align === "right" ? "text-right" : ""}`}
  >
    {children}
    {active && <span className="ml-1 text-gray-400">{dir === "asc" ? "▲" : "▼"}</span>}
  </th>
);

export default Th;
